import { cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center border-2 border-[#1a1a1a] px-2.5 py-0.5 text-xs font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-[#d62828] focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-[#1a1a1a] text-[#fefcf6]',
        secondary: 'bg-[#fcbf49] text-[#1a1a1a]',
        destructive: 'bg-[#d62828] text-[#fefcf6]',
        outline: 'bg-transparent text-[#1a1a1a] border-dashed',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      style={{ fontFamily: "'Special Elite', monospace" }}
      {...props}
    />
  );
}
Badge = React.forwardRef(Badge);
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
export default Badge;
